/* Lady V — Product form
   Add to cart with instant toast feedback + cart counter bump (no full page reload).
   If you prefer the redirect-to-cart behaviour, set data-redirect="true" on the <product-form> element.
*/
class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    if (this.form) this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
  }

  onSubmitHandler(evt) {
    evt.preventDefault();

    const submitButton = this.querySelector('[type="submit"]');
    const originalLabel = submitButton ? submitButton.innerHTML : '';
    if (submitButton) {
      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');
    }

    const body = JSON.stringify({ ...JSON.parse(serializeForm(this.form)) });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((data) => {
        if (data && data.status && data.status >= 400) {
          throw new Error(data.description || 'Could not add to cart');
        }

        // Bump the header cart counter immediately
        return fetch(`${routes.cart_url}.js`).then((r) => r.json()).then((cart) => {
          updateCartCount(cart.item_count);
          if (this.dataset.redirect === 'true') {
            window.location.href = routes.cart_url || '/cart';
            return;
          }
          showToast(`Added to cart · ${cart.item_count} item${cart.item_count === 1 ? '' : 's'}`);
          if (submitButton) {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('disabled');
            submitButton.innerHTML = originalLabel;
          }
        });
      })
      .catch((e) => {
        console.error(e);
        if (submitButton) {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
          submitButton.innerHTML = originalLabel;
        }
        showToast(e.message || 'Could not add to cart', 'error');
      });
  }
}

customElements.define('product-form', ProductForm);

// ---- Helpers ----
function updateCartCount(count) {
  document.querySelectorAll('.lvnav__cart-count').forEach((el) => {
    if (count > 0) {
      el.textContent = count;
      el.style.display = '';
    } else {
      el.style.display = 'none';
    }
  });
  const cartLink = document.querySelector('.lvnav__icon[href*="cart"]');
  if (cartLink && count > 0 && !cartLink.querySelector('.lvnav__cart-count')) {
    const span = document.createElement('span');
    span.className = 'lvnav__cart-count';
    span.textContent = count;
    cartLink.appendChild(span);
  }
}

function showToast(message, type) {
  let toast = document.getElementById('LvToast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'LvToast';
    toast.style.cssText =
      'position:fixed;top:24px;right:24px;left:24px;max-width:420px;margin-left:auto;' +
      'background:#2C4C18;color:#FFEEDC;padding:14px 20px;border-radius:999px;' +
      'font-family:Mulish,sans-serif;font-weight:600;font-size:13px;letter-spacing:0.06em;' +
      'box-shadow:0 8px 24px -8px rgba(44,76,24,0.35);' +
      'z-index:9999;opacity:0;transform:translateY(-12px);' +
      'transition:opacity .25s ease, transform .25s ease;' +
      'display:flex;align-items:center;justify-content:space-between;gap:14px;';
    document.body.appendChild(toast);
  }
  if (type === 'error') {
    toast.style.background = '#B23A3A';
  } else {
    toast.style.background = '#2C4C18';
  }
  toast.innerHTML =
    '<span>' + escapeHtml(message) + '</span>' +
    '<a href="/cart" style="color:#B1BD41;text-decoration:none;font-weight:700;letter-spacing:0.1em;text-transform:uppercase;font-size:11px;">View cart →</a>';
  requestAnimationFrame(() => {
    toast.style.opacity = '1';
    toast.style.transform = 'translateY(0)';
  });
  clearTimeout(toast._hideTimer);
  toast._hideTimer = setTimeout(() => {
    toast.style.opacity = '0';
    toast.style.transform = 'translateY(-12px)';
  }, 3500);
}

function escapeHtml(s) {
  return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
}
